import React, { Fragment, useState} from "react";
import { Link } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { Dialog, Transition } from '@headlessui/react';

// framer
import { motion } from 'framer-motion';
import { leftVariants, rightVariants, springViewport } from '../utils/framerVariants';

const Footer = ({ data, videoList }) => {

  // Dialog
  const [isOpen, setIsOpen] = useState(false);
  const [selectedEntry, setSelectedEntry] = useState(null);
  function closeModal() {
    setIsOpen(false);
    setTimeout(() => {
      setSelectedEntry(null);
    }, 200);
  }
  function openModal(entry) {
    if (entry.galeryOverlayText) {
      setSelectedEntry(entry);
      setIsOpen(true);
    }
  }

  return (
    <footer className={videoList ? "px-4 sm:px-6 lg:px-8" : "px-4 sm:px-6 lg:px-8"}>
      <article className={videoList ? "hidden" : "block mot__partner"}>
        <motion.div variants={leftVariants} initial="invisible" whileInView="visible" viewport={springViewport} className="col-span-1">
          <div className="flex flex-col gap-4 max-w-2xl">
            <h2 className="text-3xl md:text-4xl font-bold">{data.strapiMotSetting.partnerHeadline}</h2>
            <p className="text-lg md:text-xl leading-6">{data.strapiMotSetting.partnerDescription}</p>
          </div>
        </motion.div>
        <motion.div className="col-span-1 flex gap-5 md:gap-10" variants={leftVariants} initial="invisible" whileInView="visible" viewport={springViewport}>
          {data.strapiMotSetting.Partner.map((entry, index) => (
            <Fragment key={index} >
              <div className={`basis-6/12 sm:basis-4/12 lg:basis-3/12 xl:basis-2/12 flex flex-col ${entry.galeryOverlayText ? 'cursor-pointer galery-entry' : ''}`}
                onClick={() => openModal(entry)}
              >
                {entry.galeryMedia && entry.galeryMedia.file && (
                  <GatsbyImage
                    className="aspect-1/1"
                    placeholder="blurred"
                    image={getImage(entry.galeryMedia.file)}
                    alt={entry.galeryMedia.alternativeText || "Alternative Text missing"}
                  />
                )}
                <p className="pr-5 mt-2.5 md:mt-5">
                  <span className="font-bold block">{entry.galeryHeadline}</span>
                  <span className="text-sm lg:text-lg block">{entry.galeryDesc}</span>
                </p>
              </div>

              {selectedEntry === entry && (
                <Transition appear show={isOpen} as={Fragment}>
                  <Dialog as="div" className="relative z-[99999]" onClose={closeModal}>
                    <Transition.Child
                      as={Fragment}
                      enter="ease-out duration-300"
                      enterFrom="opacity-0"
                      enterTo="opacity-100"
                      leave="ease-in duration-200"
                      leaveFrom="opacity-100"
                      leaveTo="opacity-0"
                    >
                      <div className="fixed inset-0 bg-black bg-opacity-80 backdrop-blur-sm" />
                    </Transition.Child>

                    <div className="fixed inset-0 overflow-y-auto">
                      <div className="flex min-h-full items-center justify-center p-10 text-center">
                        <Transition.Child
                          as={Fragment}
                          enter="transition duration-100 ease-out"
                          enterFrom="transform scale-95 opacity-0"
                          enterTo="transform scale-100 opacity-100"
                          leave="transition duration-75 ease-out"
                          leaveFrom="transform scale-100 opacity-100"
                          leaveTo="transform scale-95 opacity-0"
                        >
                          <Dialog.Panel className="w-full max-w-3xl transform overflow-hidden bg-white text-left shadow-xl transition-all relative">
                            <div className="absolute right-0 top-0 pr-4 pt-4 z-10">
                              <button
                                type="button"
                                className="bg-white hover:text-purple hover:scale-[1.1] transition duration-200 outline-none"
                                onClick={closeModal}
                              >
                                <span className="sr-only">Close</span>
                                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-8 h-8">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
                                  </svg>
                              </button>
                            </div>
                            <div className="grid md:grid-cols-2 items-center">
                              <div className="col-span-1">
                                {selectedEntry.galeryMedia &&
                                  <GatsbyImage
                                    className="h-full"
                                    placeholder="blurred"
                                    image={getImage(selectedEntry.galeryMedia.file)}
                                    alt={selectedEntry.galeryMedia.alternativeText || "Alternative Text missing"}
                                  />
                                }
                              </div>
                              <div className="col-span-1 p-10 flex flex-col gap-5">
                                <p className="pr-5">
                                  <span className="text-sm/5 lg:text-lg/6 font-bold block">{selectedEntry.galeryHeadline}</span>
                                  <span className="text-sm/5 lg:text-lg/6 block">{selectedEntry.galeryDesc}</span>
                                </p>
                                <div className="overlayText" dangerouslySetInnerHTML={{ __html: selectedEntry.galeryOverlayText }} />
                              </div>
                            </div>
                          </Dialog.Panel>
                        </Transition.Child>
                      </div>
                    </div>
                  </Dialog>
                </Transition>
              )}
            </Fragment>
          ))}
        </motion.div>
      </article>
      <div className="pt-24 py-6 md:pt-48 grid grid-cols-2 md:grid-cols-3 items-end md:items-center justify-between gap-12 md:gap-0">
        <div className="col-span-2 md:col-span-1 flex justify-center md:justify-end space-x-4 md:order-3">
          <div>
            <a href="https://facebook.com/allianzfdn" target="_blank" rel="noreferrer" title="Facebook">
              <svg xmlns="http://www.w3.org/2000/svg" className="size-8 fill-white hover:fill-purple transition-colors duration-100" viewBox="0 0 24 24"><path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm3 8h-1.35c-.538 0-.65.221-.65.778v1.222h2l-.209 2h-1.791v7h-3v-7h-2v-2h2v-2.308c0-1.769.931-2.692 3.029-2.692h1.971v3z"/></svg>
            </a>
          </div>
          <div>
            <a href="https://x.com/allianzfdn" target="_blank" rel="noreferrer" title="Twitter">
              <svg viewBox="0 0 24 24" className="size-8 fill-white stroke-black hover:fill-purple transition-colors duration-100" xmlns="http://www.w3.org/2000/svg">
                <circle  cx="12" cy="12" r="12"/>
                <path d="m4.608 5.048 5.736 7.669-5.772 6.235H5.87l5.053-5.46 4.083 5.46h4.421l-6.059-8.1 5.373-5.804h-1.3l-4.653 5.027-3.76-5.027H4.608Zm1.91.956H8.55l8.968 11.991h-2.03L6.518 6.005Z" fill="#FFF"/>
              </svg>
            </a>
          </div>
          <div>
            <a href="https://instagram.com/allianzfdn" target="_blank" rel="noreferrer" title="Instagram">
              <svg xmlns="http://www.w3.org/2000/svg" className="size-8 fill-white hover:fill-purple transition-colors duration-100" viewBox="0 0 24 24"><path d="M14.829 6.302c-.738-.034-.96-.04-2.829-.04s-2.09.007-2.828.04c-1.899.087-2.783.986-2.87 2.87-.033.738-.041.959-.041 2.828s.008 2.09.041 2.829c.087 1.879.967 2.783 2.87 2.87.737.033.959.041 2.828.041 1.87 0 2.091-.007 2.829-.041 1.899-.086 2.782-.988 2.87-2.87.033-.738.04-.96.04-2.829s-.007-2.09-.04-2.828c-.088-1.883-.973-2.783-2.87-2.87zm-2.829 9.293c-1.985 0-3.595-1.609-3.595-3.595 0-1.985 1.61-3.594 3.595-3.594s3.595 1.609 3.595 3.594c0 1.985-1.61 3.595-3.595 3.595zm3.737-6.491c-.464 0-.84-.376-.84-.84 0-.464.376-.84.84-.84.464 0 .84.376.84.84 0 .463-.376.84-.84.84zm-1.404 2.896c0 1.289-1.045 2.333-2.333 2.333s-2.333-1.044-2.333-2.333c0-1.289 1.045-2.333 2.333-2.333s2.333 1.044 2.333 2.333zm-2.333-12c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm6.958 14.886c-.115 2.545-1.532 3.955-4.071 4.072-.747.034-.986.042-2.887.042s-2.139-.008-2.886-.042c-2.544-.117-3.955-1.529-4.072-4.072-.034-.746-.042-.985-.042-2.886 0-1.901.008-2.139.042-2.886.117-2.544 1.529-3.955 4.072-4.071.747-.035.985-.043 2.886-.043s2.14.008 2.887.043c2.545.117 3.957 1.532 4.071 4.071.034.747.042.985.042 2.886 0 1.901-.008 2.14-.042 2.886z"/></svg>
            </a>
          </div>
          <div>
            <a href="https://de.linkedin.com/company/allianzfdn" target="_blank" rel="noreferrer" title="LinkedIn">
              <svg xmlns="http://www.w3.org/2000/svg" className="size-8 fill-white hover:fill-purple transition-colors duration-100" viewBox="0 0 24 24"><path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-2 16h-2v-6h2v6zm-1-6.891c-.607 0-1.1-.496-1.1-1.109 0-.612.492-1.109 1.1-1.109s1.1.497 1.1 1.109c0 .613-.493 1.109-1.1 1.109zm8 6.891h-1.998v-2.861c0-1.881-2.002-1.722-2.002 0v2.861h-2v-6h2v1.093c.872-1.616 4-1.736 4 1.548v3.359z"/></svg>
            </a>
          </div>
        </div>
        <div className="col-span-1 order-2 md:mt-0 flex justify-center space-x-3 sm:space-x-6 lg:space-x-12 relative top-1">
            <a href="https://allianzfoundation.org/de/privacy/" className="classic-link text-sm md:text-base" title="Datenschutz">Datenschutz</a>
            <a href="https://allianzfoundation.org/de/legal-notice/" className="classic-link text-sm md:text-base" title="Impressum">Impressum</a>
        </div>
        <div className="col-span-1 order-1 md:mt-0 flex justify-start">
          <a href="https://allianzfoundation.org/de/" target="_blank" rel="noreferrer">
            <svg viewBox="0 0 202 54" className="w-32 sm:w-40 md:w-48 fill-white hover:fill-purple transition-colors duration-100" fill="#000" xmlns="http://www.w3.org/2000/svg">
                <g fillRule="nonzero">
                  <path d="M17.578 24.13h5.2L13.911.8H9.146L.28 24.13h5.2l1.833-5.099h8.432l1.833 5.1Zm-8.766-9.298 2.733-7.566 2.7 7.566H8.812ZM24.249 24.13H39.88v-4.332H29.281V.8H24.25zM41.818 24.13h15.631v-4.332H46.851V.8h-5.033zM59.387 24.13h5.033V.8h-5.033zM83.456 24.13h5.2L79.79.8h-4.766l-8.866 23.33h5.2l1.832-5.099h8.433l1.833 5.1Zm-8.766-9.298 2.733-7.566 2.7 7.566H74.69ZM90.127 24.13h4.999V8.7l9.365 15.43h5.333V.8h-5v15.432L95.46.8h-5.332zM112.195 24.13h18.032v-4.266h-12.332l12.298-14.798V.8H112.83v4.266h11.798l-12.432 14.798zM.494 53.294h5v-9.5h8.665v-4.332H5.494v-5.2h10.865v-4.299H.494zM28.962 53.56c6.833 0 11.899-5.066 11.899-11.932 0-6.865-5.066-11.931-11.899-11.931-6.866 0-11.932 5.066-11.932 11.931 0 6.866 5.066 11.932 11.932 11.932Zm-.033-4.332c-4 0-6.866-3.233-6.866-7.6 0-4.366 2.866-7.632 6.866-7.632 4 0 6.9 3.266 6.9 7.632 0 4.367-2.9 7.6-6.9 7.6ZM52.364 53.56c5.533 0 9.3-2.966 9.3-8.865V29.963h-4.667v14.732c0 3.066-1.933 4.5-4.633 4.5s-4.6-1.434-4.6-4.5V29.963h-4.699v14.732c0 5.9 3.8 8.865 9.3 8.865ZM64.934 53.294h5V37.862l9.365 15.432h5.333v-23.33h-5v15.43l-9.365-15.43h-5.333zM88.37 53.294h7.832c6.433 0 12.065-3.733 12.065-11.666 0-7.965-5.632-11.665-12.065-11.665H88.37v23.33Zm4.999-4.333V34.263h2.333c3.833 0 7.5 1.866 7.5 7.365 0 5.5-3.667 7.333-7.5 7.333h-2.333ZM125.237 53.294h5.199l-8.866-23.33h-4.766l-8.865 23.33h5.2l1.832-5.1h8.433l1.833 5.1Zm-8.766-9.3 2.733-7.565 2.7 7.566h-5.433ZM134.107 53.294h5V34.263h6.899v-4.3h-18.798v4.3h6.899zM147.344 53.294h5.032v-23.33h-5.032zM167.013 53.56c6.832 0 11.898-5.066 11.898-11.932 0-6.865-5.066-11.931-11.898-11.931-6.866 0-11.932 5.066-11.932 11.931 0 6.866 5.066 11.932 11.932 11.932Zm-.034-4.332c-4 0-6.866-3.233-6.866-7.6 0-4.366 2.867-7.632 6.866-7.632 4 0 6.9 3.266 6.9 7.632 0 4.367-2.9 7.6-6.9 7.6ZM181.582 53.294h5V37.862l9.365 15.432h5.333v-23.33h-5v15.43l-9.365-15.43h-5.333z"/>
                </g>
            </svg>
          </a>
        </div>
      </div>
    </footer>
  )
}

export default Footer;
